<form autocomplete="off" [formGroup]="addressForm">
  <div class="flex justify-between items-baseline">
    <h4 class="user-profile-heading">Addresses</h4>
    <button mat-icon-button matTooltip="Add Entry" [matMenuTriggerFor]="addressMenu">
      <mat-icon class="plus">add</mat-icon>
    </button>
  </div>
  <div class="flex">
    <mat-menu #addressMenu="matMenu">
      @for (content of address_content; track content) {
        @if (!content.isSelected) {
          <button (click)="addAddressType(content)" mat-menu-item>{{ content.name }}</button>
        }
      }
    </mat-menu>
  </div>

  <div formArrayName="addresses">
    @for (address of addresseListArr.controls; track address; let i = $index) {
      <ng-container [formGroupName]="i">
        <div class="flex flex-row w-full gap-3 place-items-center">
          <!-- address type -->
          <mat-form-field class="w-[25%]">
            <mat-label>Type</mat-label>
            <mat-select [disabled]="address?.value?.address_class == 'true'" matNativeControl formControlName="address_type_id" [ngClass]="{'line-through': address?.value?.address_class == 'true'}">
              @for (content of address_content; track content) {
                <mat-option value="{{content.name}}">{{content.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!-- address1 -->
          <mat-form-field class="grow">
            <mat-label>Address</mat-label>
            <input [class]="address?.value?.address_class == 'true' ? 'not-allowed' : ''"  [readonly]="address?.value?.address_class == 'true'" [appInputMaxLength] matInput formControlName="address1" [ngClass]="{'line-through': address?.value?.address_class == 'true'}" appDisableAutofill>
            @if (address?.get('address1')?.errors && submitted) {
              <mat-error>
                Please enter address
              </mat-error>
            }
          </mat-form-field>
          @if (address?.value?.address_class == '') {
            <button mat-icon-button class="close" title="Undo" (click)="clearAddress(address.value,i)"><mat-icon>close</mat-icon></button>
          }
          @if (address?.value?.address_class == 'true') {
            <button mat-icon-button (click)="refreshAddress(address.value,i)"><mat-icon>replay</mat-icon></button>
          }
          @if (type!='admin') {
            <mat-checkbox matTooltip="Default Address" [matTooltipDisabled]="address?.value?.isSelected==false" (change)="addressCheckBoxvalue($event,address.value,i)" [checked]="address?.value?.isSelected==true || type == 'plan' || type=='add-user'">
            </mat-checkbox>
          }
        </div>
        <div class="flex flex-row w-full gap-3">
          <!-- address2 -->
          <mat-form-field class="w-[25%]">
            <mat-label>Address 2</mat-label>
            <input [class]="address?.value?.address_class == 'true' ? 'not-allowed' : ''" [readonly]="address?.value?.address_class == 'true'"  [appInputMaxLength] matInput formControlName="address2" [ngClass]="{'line-through': address?.value?.address_class == 'true'}" appDisableAutofill>
          </mat-form-field>
          <!-- city -->
          <mat-form-field class="w-[25%]">
            <mat-label>City</mat-label>
            <input [class]="address?.value?.address_class == 'true' ? 'not-allowed' : ''" [readonly]="address?.value?.address_class == 'true'"  [appInputMaxLength] matInput formControlName="city" [ngClass]="{'line-through': address?.value?.address_class == 'true'}" appDisableAutofill>
            @if (address?.get('city')?.errors && submitted) {
              <mat-error>Please enter city</mat-error>
            }
          </mat-form-field>
          <!-- state_id -->
          <mat-form-field class="w-[10%]">
            <mat-label>State</mat-label>
            <mat-select panelWidth="200" [disabled]="address?.value?.address_class == 'true'" placeholder="State" #State formControlName="state_id" [ngClass]="{'line-through': address?.value?.address_class == 'true'}">
              @for (el of state_data; track el) {
                <mat-option [value]="el.abbreviation">{{ el.abbreviation }}</mat-option>
              }
            </mat-select>
            @if (address?.get('state_id')?.errors && submitted) {
              <mat-error>Please select state</mat-error>
            }
          </mat-form-field>
          <!-- zip -->
          <mat-form-field class="w-[15%]">
            <mat-label>Zip</mat-label>
            <input matInput [class]="address?.value?.address_class == 'true' ? 'not-allowed' : ''" [readonly]="address?.value?.address_class == 'true'"  formControlName="zip" [minlength]="5" [maxlength]="5" appNumbersOnly (input)="getCounties(i, '', true)" [ngClass]="{'line-through': address?.value?.address_class == 'true'}" appDisableAutofill>
            @if (address?.get('zip')?.errors && submitted) {
              <mat-error>Please enter correct zip</mat-error>
            }
          </mat-form-field>
          <!-- county -->
          @if (type!='profile' && type!= 'admin' && type!='add-user') {
            <mat-form-field class="w-[25%]">
              <mat-label>County</mat-label>
              <mat-select [disabled]="address?.value?.address_class == 'true'" placeholder="County" formControlName="county" [ngClass]="{'line-through': address?.value?.address_class == 'true'}">
                @if (address?.value?.county.length>0) {
                  <mat-option class="selected-county" [value]="address?.value?.county">{{ address?.value?.county }}</mat-option>
                }
                @for (country of countiesData; track country) {
                  <mat-optgroup label="{{ country.state_name }}">
                    @for (county of country.counties; track county) {
                      <mat-option (click)="changeOption(country,i)" [value]="county?.county_name">{{ county?.county_name }}</mat-option>
                    }
                  </mat-optgroup>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </ng-container>
    }
  </div>

</form>
